import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import api from "@/lib/api";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Libro from "@/components/site/Libro";
import Formati from "@/components/site/Formati";
import Mondo from "@/components/site/Mondo";
import Personaggi from "@/components/site/Personaggi";
import Quiz from "@/components/site/Quiz";
import Saga from "@/components/site/Saga";
import Interludio from "@/components/site/Interludio";
import Autrice from "@/components/site/Autrice";
import Eventi from "@/components/site/Eventi";
import Galleria from "@/components/site/Galleria";
import Blog from "@/components/site/Blog";
import Media from "@/components/site/Media";
import PressKit from "@/components/site/PressKit";
import Contatti from "@/components/site/Contatti";
import Footer from "@/components/site/Footer";
import AdminPage from "@/components/site/AdminPage";
import { setLenis, scrollToId } from "@/lib/lenis";
import { initAnalytics } from "@/lib/analytics";

function App() {
  const isRiservata = window.location.pathname === "/riservata";
  const wantsQuiz = window.location.pathname === "/quiz";
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    initAnalytics();
    if (!isRiservata) {
      api.post("/track", { path: window.location.pathname }).catch(() => {});
    }
    let quizTimer;
    if (wantsQuiz) {
      quizTimer = setTimeout(() => scrollToId("quiz"), 700);
    }
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(quizTimer);
      lenis.destroy();
    };
  }, [wantsQuiz]);

  if (isRiservata) {
    return (
      <div className="App">
        <div className="grain-overlay" aria-hidden="true" />
        <AdminPage />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#133E4A",
              border: "1px solid rgba(197,155,39,0.4)",
              color: "#F8F4EB",
            },
          }}
        />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Libro />
        <Formati />
        <Mondo />
        <Personaggi />
        <Quiz />
        <Saga />
        <Interludio />
        <Autrice />
        <Eventi />
        <Galleria />
        <Blog />
        <Media />
        <PressKit />
        <Contatti />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#133E4A",
            border: "1px solid rgba(197,155,39,0.4)",
            color: "#F8F4EB",
          },
        }}
      />
    </div>
  );
}

export default App;
